






















import { defineComponent, ref } from "@vue/composition-api";
import CaldateModel from "@/ts/models/caldateClass";

export default defineComponent({
  name: "CaldateChip",

  props: {
    caldate: {
      type: Object
    },
    small: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { root }) {
    const click = () => {
      if (props.clickable && props.caldate) {
        root.$router.push(
          "/place/" +
            props.caldate.place_id +
            "/calendar#" +
            props.caldate.start.split(" ")[0]
        );
      }
    };

    return {
      click
    };
  }
});
